import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation, Input } from '@angular/core';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { NgxSmartModalService, ProgressComponent } from '@bssh/comp-lib';
import { interval } from 'rxjs';
import { take } from 'rxjs/operators';
import { ICreateAnalysisProgressBarModalInput } from '../model/action-modal';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-create-analysis-progress-bar-modal',
  templateUrl: './create-analysis-progress-bar-modal.component.html',
  styleUrls: ['./create-analysis-progress-bar-modal.component.scss'],
})
export class CreateAnalysisProgressBarModalComponent extends BaseModalComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() modalTitle: string;
  @Input() description: string;
  modalType = 'CreateAnalysisProgressBarModal';
  modalClass = 'modal-dialog-centered';

  @ViewChild('progressBar', { static: false }) progressBar: ProgressComponent;

  constructor(public ngxSmartModalService: NgxSmartModalService) {
    super(ngxSmartModalService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    // Set modalTitle and description from the data input if provided
    this.subs.sink = this.data.subscribe((modalInput: ICreateAnalysisProgressBarModalInput) => {
      if (modalInput) {
        if (modalInput.modalTitle) {
          this.modalTitle = modalInput.modalTitle;
        }
        if (modalInput.description) {
          this.description = modalInput.description;
        }
      }
    });
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    // TODO: Basically just faking the progress here, could be nice to actually reflect real progress
    interval(1000).pipe(take(20)).subscribe({
      next: (i) => {
        this.progressBar.set(i*5);
      },
    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onCompleted(): void {
    this.modal.close();
  }

}
